export interface WorkoutUserAction {
  answer: number;
  reactionTime: number;
  timestamp: number;
}

export type WorkoutTrial = WorkoutUserAction[];

export enum ExitCode {
  None = 'None',
  TotalRuns = 'TotalRuns',
  GoodRuns = 'GoodRuns',
  ConsecutiveGoodRuns = 'ConsecutiveGoodRuns',
  BadRuns = 'BadRuns',
  InitialBadRuns = 'InitialBadRuns',
  ConsecutiveBadRuns = 'ConsecutiveBadRuns',
  TimeIsUp = 'TimeIsUp',
  Canceled = 'Canceled',
}

export interface WorkoutUnityResult {
  exitCode: ExitCode;
  stats: {
    accuracy: number;
    badRuns: number;
    endDifficulty: number;
    goodRuns: number;
    maxDifficulty: number;
    meanDifficulty: number;
    minDifficulty: number;
    reactionTimeAverage: number;
    reactionTimeBadRunAverage: number;
    reactionTimeGoodRunAverage: number;
    score: number;
    startDifficulty: number;
  };
  trials: WorkoutTrial[];
  config?: string;
}
